<header-title [model]="headerTitle"></header-title>

<section class="card mt-4">
    <header class="card-header">
        <h3 class="text-gray-600 m-0"><i class="fas fa-tasks me-2"></i>Add New Company</h3>
    </header>
    <div class="card-body py-5">
        <div class="container">
            <form *ngIf="addCompanyFormGroup" (submit)="addCompany()" [formGroup]="addCompanyFormGroup">
                    <div class="">
                        <error-message [errors]="errors"></error-message>
                        <h3 class="mt-5 text-primary">Company Details</h3>
                        <div class="row mt-3">
                            <div class="col-md-6 col-lg-4">
                                <div class="form-group">
                                    <label class="control-label">
                                        Legal Name
                                    </label>
                                    <input type="text" class="form-control" formControlName="legalName" />
                                    <div *ngIf="legalName?.invalid">
                                        <label class="control-label text-danger" *ngIf="legalName?.errors.required">
                                            Required.
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6 col-lg-4">
                                <div class="form-group">
                                    <label class="control-label">
                                        Trading Name
                                    </label>
                                    <input id="tradingName" name="tradingName" class="form-control" formControlName="tradingName" />
                                </div>
                            </div>
                            <div class="col-md-6 col-lg-4">
                                <label class="control-label">
                                    Company Type
                                </label>
                                <select name="companyTypeId" class="form-select" formControlName="companyTypeId">
                                    <option *ngFor="let companyType of companyTypesList" [value]="companyType.id">{{companyType.description}}</option>
                                </select>
                            </div>
                        </div>
                        <div class="row mt-3">
                            <div class="col-md-6 col-lg-4">
                                <label class="control-label">
                                    Aggregator
                                </label>
                                <select name="aggregatorId" class="form-select" formControlName="aggregatorId">
                                    <option [ngValue]="null">None</option>
                                    <option *ngFor="let aggregator of aggregatorsList" [value]="aggregator.id">{{aggregator.name}}</option>
                                </select>
                            </div>
                            <div class="col-md-6 col-lg-4">
                                <label class="control-label">
                                    Parent Entity (authorise reporting visibility)
                                </label>
                                <select name="parentId" class="form-select" formControlName="parentId">
                                    <option [ngValue]="null">None</option>
                                    <option *ngFor="let company of companiesList" [value]="company.id">{{company.legalName}}</option>
                                </select>
                            </div>
                            <div class="col-md-6 col-lg-4">
                                <label class="control-label">
                                    Parent Entity Access (On: Full / Off: Read-Only)
                                </label>
                                <input type="checkbox" id="parentFullAccess" name="parentFullAccess" class="form-control" formControlName="parentFullAccess" appToggle />
                            </div>
                        </div>
                        <div class="row mt-3">
                            <div class="col-md-6 col-lg-3">
                                <div class="form-group">
                                    <label class="control-label">ACL Number <span *ngIf="addCompanyFormGroup.value.companyTypeId==1">authorised under</span></label>
                                    <input type="text" id="aclNr" name="aclNr" class="form-control" formControlName="aclNr" />
                                    <div *ngIf="aclNr?.invalid">
                                        <label class="control-label text-danger" *ngIf="aclNr?.errors.required">
                                            Required.
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6 col-lg-3" *ngIf="addCompanyFormGroup.value.companyTypeId==1">
                                <div class="form-group">
                                    <label class="control-label">ACR Number</label>
                                    <input type="text" id="acrNr" name="acrNr" class="form-control" formControlName="acrNr" />
                                    <div *ngIf="acrNr?.invalid">
                                        <label class="control-label text-danger" *ngIf="acrNr?.errors.required">
                                            Required.
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6 col-lg-3">
                                <div class="form-group">
                                    <label class="control-label">ACN</label>
                                    <input type="text" id="acn" name="ACN" class="form-control" formControlName="acn" />
                                </div>
                            </div>
                            <div class="col-md-6 col-lg-3">
                                <div class="form-group">
                                    <label class="control-label">ABN</label>
                                    <input type="text" id="ABN" name="ABN" class="form-control" formControlName="abn" />
                                    <div *ngIf="abn?.invalid">
                                        <label class="control-label text-danger" *ngIf="abn?.errors.required">
                                            Required.
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <hr class="mt-5" />
                        <h3 class="mt-2 text-primary">Key Dates</h3>
                        <div class="row">
                            <div class="col-md-4 col-lg-3">
                                <div class="form-group">
                                    <label class="control-label">ACL Anniversary Date (dd/mm)</label>
                                    <input id="aclExpiry"
                                           name="aclExpiry"
                                           class="form-control"
                                           formControlName="aclExpiry"
                                           type="text"
                                           placeholder="DD/MM/YYYY"
                                           bsDatepicker
                                           [bsConfig]="{ isAnimated: true, containerClass: 'theme-default', dateInputFormat : 'DD/MM/YYYY' }">
                                </div>
                            </div>
                            <div class="col-md-4 col-lg-3">
                                <div class="form-group">
                                    <label class="control-label">PII Expiry Date</label>
                                    <input id="piExpiry"
                                           name="piExpiry"
                                           class="form-control"
                                           formControlName="piExpiry"
                                           type="text"
                                           placeholder="DD/MM/YYYY"
                                           bsDatepicker
                                           [bsConfig]="{ isAnimated: true, containerClass: 'theme-default', dateInputFormat : 'DD/MM/YYYY' }">
                                </div>
                            </div>
                            <div class="col-md-4 col-lg-3">
                                <div class="form-group">
                                    <label class="control-label">AFCA Membership Expiry Date</label>
                                    <input id="afcaExpiry"
                                           name="afcaExpiry"
                                           class="form-control"
                                           formControlName="afcaExpiry"
                                           type="text"
                                           placeholder="DD/MM/YYYY"
                                           bsDatepicker
                                           [bsConfig]="{ isAnimated: true, containerClass: 'theme-default', dateInputFormat : 'DD/MM/YYYY' }">
                                </div>
                            </div>
                        </div>
                        <hr class="mt-5" />
                        <h3 class="mt-2 text-primary">Contact Details</h3>
                        <div class="row mt-3">
                            <div class="col-md-12 col-lg-4">
                                <div class="form-group">
                                    <label class="control-label">Web Site</label>
                                    <input type="email" id="website" name="website" class="form-control" formControlName="website" />
                                </div>
                            </div>
                            <div class="col-md-4 col-lg-2">
                                <div class="form-group">
                                    <label class="control-label">Mobile Number</label>
                                    <input type="text" id="mobileNr" name="mobileNr" class="form-control" formControlName="mobileNr" />
                                </div>
                            </div>
                            <div class="col-md-4 col-lg-2">
                                <div class="form-group">
                                    <label class="control-label">Phone Number</label>
                                    <input type="text" id="phoneNr" name="phoneNr" class="form-control" formControlName="phoneNr" />
                                </div>
                            </div>
                            <div class="col-md-4 col-lg-2">
                                <div class="form-group">
                                    <label class="control-label">Fax Number</label>
                                    <input type="text" id="faxNr" name="faxNr" class="form-control" formControlName="faxNr" />
                                </div>
                            </div>
                        </div>
                        <hr class="mt-5" />
                        <h3 class="mt-2 text-primary">Account Details</h3>
                        <div class="row mt-3">
                            <div class="col-md-4 col-lg-2">
                                <label class="control-label">
                                    Is Active
                                </label>
                                <input type="checkbox" id="isActive" name="isActive" class="form-control" formControlName="isActive" appToggle />
                            </div>
                            <div class="col-md-8 col-lg-4">
                                <label class="control-label">
                                    Max number of Users allocated to this account
                                </label>
                                <input type="number" id="usersNr" name="usersNr" class="form-control" formControlName="usersNr" />
                                <div *ngIf="usersNr?.invalid">
                                    <label class="control-label text-danger" *ngIf="usersNr?.errors.min">
                                        At least one user must be allocated to this account
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-3">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label class="control-label"> Notes </label>
                                    <textarea class="form-control" formControlName="notes" rows="2"></textarea>
                                </div>
                            </div>
                        </div>
                    </div>
                    <footer class="panel-footer mt-3">
                        <div class="row">
                            <div class="col-12 text-end">
                                <button class="btn btn-outline-primary" type="button" (click)="onBack()">Back</button>
                                <button class="btn btn-primary ms-1" type="submit" [disabled]="!addCompanyFormGroup.valid">Save</button>
                            </div>
                        </div>
                    </footer>
            </form>
        </div>
    </div>
</section>
